import { Form } from 'formik';
import styled from 'styled-components';

export const ModalFormLayout = styled(Form)`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  align-self: stretch;
`;
